<template>
  <div class="combination">
    <div class="title-box">
      <span class="line-name">子题</span>
      <span class="line-dec" v-if="!readOnly">管理子题</span>
    </div>
    <div class="combination-item-box" v-for="(question, index) in groupSubDataCopy" :key="index">
      <el-form :model="question" :rules="rule" ref="combination" label-width="100px" class="demo-ruleForm" @validate="validateQuestions">
        <div class="combination-item-container">
          <div class="combination-item-order">
            {{ index + 1 }}
          </div>
          <div class="combination-item-content">
            <div class="question-item" :ref="'name'">
              <div class="title-box">
                <span class="line-name">题干</span>
                <span v-if="!readOnly">
                  <span class="line-dec">请在下方输入框填写题干描述&nbsp;&nbsp;&nbsp; </span>
                  <el-button
                    class="insert-blank"
                    v-if="question['items'].value == 'input'"
                    @click="insertBlank(question['exam_questions.ds_order'], index)"
                  >
                    插入填空
                  </el-button></span
                >
              </div>
              <el-form-item prop="name" label=" ">
                <div class="readonly-name" v-if="readOnly" @click="showImage" v-html="examName(question)"></div>
                <DsfUEditor
                  v-else-if="showUeditors && !readOnly"
                  :readOnly="readOnly"
                  v-model="question['name']"
                  :showLabel="false"
                  :ref="'names'"
                  :richTxtHeight="200"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                />
              </el-form-item>
            </div>
            <div class="question-item" :ref="'exam_questions_options'" v-if="componentIs[question['items'].value]">
              <el-form-item prop="exam_questions_options" label=" ">
                <component
                  :readOnly="readOnly"
                  :exam_questions_options="question['exam_questions_options']"
                  :dsOrder="question['exam_questions.ds_order']"
                  :is="componentIs[question['items'].value]"
                  :saveStatus="saveStatus"
                  ref="group_options"
                  @validate-single="validates"
                  @add-judge="addJudge"
                ></component>
              </el-form-item>
            </div>
            <!-- 提示 -->
            <div class="question-item" :ref="'hint'">
              <div class="title-box">
                <span class="line-name">提示</span>
                <span class="line-dec" v-if="!readOnly">请在下方框内填写提示</span>
              </div>
              <el-form-item prop="hint" label=" ">
                <div class="readonly-name" v-if="readOnly" @click="showImage" v-html="question['hint']"></div>
                <DsfUEditor
                  v-else-if="showUeditors && !readOnly"
                  :readOnly="readOnly"
                  v-model="question['hint']"
                  :showLabel="false"
                  :richTxtHeight="200"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                  :ref="'hints'"
                />
              </el-form-item>
            </div>
            <!-- 解析 -->
            <div class="question-item" :ref="'parse'">
              <div class="title-box">
                <span class="line-name">解析</span>
                <span class="line-dec" v-if="!readOnly">请在下方框内填写答案解析</span>
              </div>
              <el-form-item prop="parse" label=" ">
                <div class="readonly-name" v-if="readOnly" @click="showImage" v-html="question['parse']"></div>
                <DsfUEditor
                  v-else-if="showUeditors && !readOnly"
                  :readOnly="readOnly"
                  v-model="question['parse']"
                  :showLabel="false"
                  :richTxtHeight="200"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                  :ref="'parses'"
                />
              </el-form-item>
            </div>
          </div>
          <div class="combination-item-delete" v-if="!readOnly">
            <DsfButton :disabled="readOnly" @click="deleteQustion(question)"> 删除子题</DsfButton>
          </div>
        </div>
      </el-form>
    </div>
    <div class="operation-wrapper" v-if="!readOnly">
      <DsfButton type="plain" v-for="item in items" :key="item.value" @click="selectItems(item)">
        {{ item.text }}
      </DsfButton>
    </div>
  </div>
</template>

<script>
import DsfCompletion from "./Completion.vue";
import DsfJudge from "./Judge.vue";
import DsfMultiple from "./Multiple.vue";
import DsfSingle from "./Single.vue";
export default {
  name: "DsfCombination",
  mixins: [$mixins.examquestion],
  components: {
    DsfCompletion,
    DsfJudge,
    DsfMultiple,
    DsfSingle,
  },
  props: {
    itemsData: {
      type: Array,
      // default: [],
    },
    difficultyData: {
      type: Array,
      // default: [],
    },

    readOnly: {
      type: Boolean,
      default: false,
    },
    groupSubData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    saveStatus: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    var validateOptions = (rule, value, callback) => {
      var options = value.filter((item) => item["exam_questions_options.ds_deleted"] !== 1);
      if (options?.length == 0) {
        callback(new Error("请添加选项"));
      } else {
        var rightArray = options.filter((item) => item["exam_questions_options.is_right"]?.value == 1);

        //选择题
        if (options[0]["type"] == "single" || options[0]["type"] == "multiple") {
          if (options.length < this.minOptions || options.length > this.maxOptions) {
            callback(new Error(`选择题的选项至少为${this.minOptions}个，最多为${this.maxOptions}个`));
          } else {
            var isNull = options.some(
              (item) => (item["exam_questions_options.imgs"] == "[]" || !item["exam_questions_options.imgs"]) && !item["exam_questions_options.name"]
            );
            if (isNull) {
              callback(new Error(`选项内容不能为空`));
            } else {
              if (options[0]["type"] == "multiple") {
                if (rightArray?.length < 2) {
                  callback(new Error("多选题的正确答案至少两个"));
                } else {
                  callback();
                }
              } else if (options[0]["type"] == "single") {
                if (rightArray?.length != 1) {
                  callback(new Error("请设置正确答案"));
                } else {
                  callback();
                }
              }
            }
          }
        }

        //判断题
        if (options[0]["type"] == "judge") {
          if (rightArray?.length != 1) {
            callback(new Error("请设置正确答案"));
          } else {
            callback();
          }
        }

        //填空题
        if (options[0]["type"] == "completion") {
          if (options.length < this.minNumbers || options.length > this.maxNumbers) {
            callback(callback(new Error(`填空数量至少为${this.minNumbers}个，最多为${this.maxNumbers}个`)));
          } else {
            var isnull = options.some((item) => item["exam_questions_options.name"] == "");
            if (isnull) {
              callback(new Error(`填空内容不能为空`));
            } else {
              callback();
            }
          }
        }
      }
    };
    var validateLength = (rule, value, callback) => {
      if (value) {
        var length = this.getTextLength(value);
        if (length > this.ueditorlength) {
          callback(new Error(`该项长度不超过${this.ueditorlength}字符`));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      showUeditors: false,
      dsorder: 1,
      validateResult: [],
      lengths: 0,
      ueIdList: [],
      itemsValue: {},
      componentIs: {
        radio: DsfSingle.name,
        checkbox: DsfMultiple.name,
        judge: DsfJudge.name,
        input: DsfCompletion.name,
      },
      questionItems: "",
      rule: {
        name: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { validator: validateLength, trigger: "blur" },
        ],
        exam_questions_options: [{ validator: validateOptions, trigger: "change" }],
        parse: [{ validator: validateLength, trigger: "blur" }],
        hint: [{ validator: validateLength, trigger: "blur" }],
      },
    };
  },
  computed: {
    items() {
      return this.itemsData.filter((item) => item.value != "group");
    },
    groupSubDataCopy() {
      return this.groupSubData.filter((item) => item["exam_questions.ds_deleted"] !== 1);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.lengths = this.groupSubData.length;
      this.groupSubData.forEach((item, index) => {
        this.$set(this.groupSubData[index], "exam_questions.ds_order", index);
      });
    });
  },

  methods: {
    showImage(e) {
      if (this.readOnly) {
        if (e.target.nodeName.toLowerCase() === "img") {
          this.$emit("add-show-image", [e.target.src]);
        }
      }
    },

    addJudge(newdata, dsOrder) {
      this.groupSubData.forEach((ele, index) => {
        if (ele["exam_questions.ds_order"] == dsOrder) {
          this.$set(this.groupSubData[index], "exam_questions_options", newdata);
        }
      });
    },

    examName(question) {
      if (question.items.value == "input") {
        let name = question["name"].replace(/<\/?p>/g, "").replace(/（）|\(\)/g, (word, p) => {
          return "_____ ";
        });
        return name;
      }
      return question["name"];
    },

    insertBlank(ds_order, index) {
      // var editor = window.UE.getEditor(this.$refs.names[index].ueId);
      // editor.focus();
      // editor.execCommand("inserthtml", "（）");
      this.groupSubData.forEach((item, _index) => {
        if (item["exam_questions.ds_order"] == ds_order) {
          if (this.groupSubData[_index].exam_questions_options.length < this.maxNumbers) {
            var editor = window.UE.getEditor(this.$refs.names[index].ueId);
            editor.focus();
            editor.execCommand("inserthtml", "（）");
            this.groupSubData[_index].exam_questions_options.push({
              "exam_questions_options.name": "",
              "exam_questions_options.ds_order": this.groupSubData[_index].exam_questions_options.length,
              type: "completion",
            });
          } else {
            dsf.layer.message(`填空数量最多为${this.maxNumbers}个`, false);
            return;
          }
        }
      });
    },

    //新增子题
    selectItems(item) {
      this.questionItems = item;
      var combination = this.$refs.combination ? this.$refs.combination : [];
      if (combination.length == 0) {
        this.addQuestion();
      } else {
        var pass = this.validates();
        if (pass) {
          this.addQuestion();
        }
      }
    },

    validateQuestions(name, ispass, text) {
      this.validateResult.push({ name, ispass });
    },

    //验证
    validates(isLocated = true) {
      this.validateResult = [];
      var isPass = false;
      var result = true;
      var combination = this.$refs.combination;
      if (combination) {
        combination.forEach((element) => {
          element.validate((valid) => {
            if (valid) {
              isPass = true;
            } else {
              isPass = false;
              result = false;
              if (isLocated) {
                //定位到首个错误位置
                setTimeout(() => {
                  var _index = _.findIndex(this.validateResult, (item) => {
                    return !item.ispass;
                  });
                  if (_index > -1) {
                    var err = this.validateResult[_index];
                    var num = Math.floor(_index / 4);
                    const top = this.$refs[err.name][num].getBoundingClientRect().top;
                    const scrollTop = document.querySelector(".ds-virtual-scroll-box").scrollTop;
                    document.querySelector(".ds-virtual-scroll-box").scrollTo({
                      top: top + scrollTop - 60,
                      behavior: "smooth",
                    });
                    return false;
                  }
                }, 500);
              }
            }
          });
        });
      }
      return isPass && result;
    },

    addQuestion() {
      var order = this.groupSubDataCopy.length;
      if (order < this.maxSubQquestion) {
        var inputRight = this.checkoutInput();
        if (inputRight) {
          dsf.layer.message(`${inputRight}填空答案数量与题目不匹配`, false);
          return;
        } else {
          this.lengths += 1;
          this.dsorder += 1;
          this.groupSubData.push({
            name: "",
            types: "",
            exam_questions_options: [],
            difficulty: "",
            items: this.questionItems,
            labels: "",
            hint: "",
            parse: "",
            status: { text: "启用", value: "1" },
            treeinfo: { globalid: null, level: null, pid: null },
            "exam_questions.ds_deleted": 0,
            "exam_questions.ds_order": this.dsorder,
          });
        }
      } else {
        dsf.layer.message(`子题个数最多为 ${this.maxSubQquestion}个`, false);
      }
    },

    deleteQustion(item) {
      dsf.layer
        .confirm("确认要删除该题吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          //确认
          this.groupSubData.forEach((ele, index) => {
            if (ele["exam_questions.ds_order"] == item["exam_questions.ds_order"]) {
              this.lengths -= 1;
              if (item._id) {
                this.$set(this.groupSubData[index], "exam_questions.ds_deleted", 1);
                this.$delete(this.groupSubData[index], "exam_questions.ds_order");
              } else {
                this.groupSubData.splice(index, 1);
              }
            }
          });
        })
        .catch(() => {
          //取消
        });
    },

    checkoutInput() {
      var result = "";
      this.groupSubDataCopy.forEach((item, index) => {
        if (item["exam_questions.ds_deleted"] != 1 && item["items"].value == "input") {
          var numbers = this.searchTimes(item.name, "（）") + this.searchTimes(item.name, "()");
          // console.log(item);
          var length = item["exam_questions_options"].filter((ele) => {
            return ele["exam_questions_options.ds_deleted"] != 1;
          }).length;
          if (numbers != length) {
            result += `第${index + 1}题 `;
          }
        }
      });
      return result;
    },
    searchTimes(text, word) {
      var index = text.indexOf(word);
      var num = 0;
      while (index !== -1) {
        num++;
        index = text.indexOf(word, index + 1);
      }
      return num;
    },
  },
  watch: {
    lengths(val) {
      if (this.dsorder == 0) {
        this.dsorder = val;
      }
      if (!this.readOnly) {
        setTimeout(() => {
          this.showUeditors = true;
        }, 500);

        setTimeout(() => {
          var ueList = [];
          if (this.$refs.names) {
            // console.log(this.$refs.names);
            this.$refs.names.forEach((item) => {
              ueList.push(item.ueId);
            });
          }
          if (this.$refs.parses) {
            this.$refs.parses.forEach((item) => {
              ueList.push(item.ueId);
            });
          }
          if (this.$refs.hints) {
            this.$refs.hints.forEach((item) => {
              ueList.push(item.ueId);
            });
          }

          this.$emit("set-ueditorids", ueList);
          ueList.forEach((item) => {
            $("#" + item)
              .find(".edui-editor-toolbarbox")
              .addClass("edui-editor-toolbarboxnone");
          });
        }, 700);
      }
    },

    saveStatus(val) {
      if (val) {
        var pass = this.validates();
        if (pass) {
          if (this.groupSubDataCopy.length < this.minSubQquestion) {
            dsf.layer.message(`请添加子题，子题数量至少为${this.minSubQquestion}个`, false);
            this.$emit("set-savestatus", false);
            this.$emit("set-validatesuc", false);
            return;
          } else {
            var isRight = this.checkoutInput();
            // console.log(isRight);
            if (isRight) {
              dsf.layer.message(`${isRight}填空答案数量与题目不匹配`, false);
              this.$emit("set-savestatus", false);
              this.$emit("set-validatesuc", false);
              return;
            } else {
              this.$emit("set-savestatus", false);
              this.$emit("set-validatesuc", true);
              return false;
            }
          }
        } else {
          this.$emit("set-savestatus", false);
          this.$emit("set-validatesuc", false);
          return false;
        }
      }
    },
  },
};
</script>

<style></style>
